export default __webpack_public_path__ + "static/image-06-480x298-1437411ad8c1df7cd9074613003d3613.jpg";